import React from 'react';
import Footer from '../../components/footer';


import "../../css/seller/login.css"
import "../../css/admin/login.css"

export default function AdminLogin() {
 return (
  <div>
   <nav className="navbar navbar-expand-lg" style={{ backgroundColor: "rgba(0, 102, 255, 0.45)" }}>
    <div className="container">
     <a className="navbar-brand d-flex pt-3" href="-">
      <img src={"/img/logo.png"} className="img-log" alt="img-logo" width={60} height={60}></img>
      <div className="logo-title  ps-2 d-flex" style={{ color: "#0066FF" }}>W-Shop</div></a>
     <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
      <span className="navbar-toggler-icon"></span>
     </button>

     <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
      <div className="offcanvas-header">
       <a className="navbar-brand d-flex" href="-">
        <img src={"/img/logo.png"} className="img-log" alt="img-logo" width={60} height={60}></img>
        <div className="logo-sidebar  ps-2">W-Shop</div></a>
       <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
       <ul className="navbar-nav ms-auto me-5">
        <a href="=" className=" text-decoration-none  beranda">
         Beranda W-Shop
        </a>
       </ul>
      </div>

     </div>
    </div>
   </nav>

   <div className='main'>
    <div className='container py-6'>
     <div className='row py-5'>
      <div className='col-12 col-lg-6 mb-5'>
       <h1 className='jadi mt-2'>Admin Centre</h1>
       <p className='kelola'>Siap membantu anda dalam kegiatan jual beli online</p>
       <img alt='' src='/img/admin.png' className=' d-block ms-auto me-auto w-50' />
      </div>
      <div className='col-12 col-lg-6'>
       <div className='tabs py-5 ms-auto me-auto px-4'>
        <h1 className=' titleLogAdmin'>Log In ke Admin Centre</h1>
        <hr className='mb-5 '/>
        <form>
         <div className="mb-4">
          <label for="exampleInputEmail1 mb-3" className="form-label  labelLogAdmin">Email</label>
          <input type="email" className="form-control inputLogAdmin" id="exampleInputEmail1" aria-describedby="emailHelp" />
         </div>
         <div className="mb-4">
          <label for="exampleInputPassword1" className="form-label labelLogAdmin">Password</label>
          <input type="password" className="form-control  inputLogAdmin" id="exampleInputPassword1" />
         </div>
         <div className="mb-4 form-check">
          <input type="checkbox" className="form-check-input" id="exampleCheck1" />
          <label className="form-check-label" for="exampleCheck1">Ingatkan Saya</label>
         </div>
         <button type="submit" className="btn btn-primary w-100 bLoginAdmin mt-4">Submit</button>
        </form>
       </div>
      </div>
     </div>
    </div>
   </div>
   <Footer />
  </div>
 );
}
